module.exports = __webpack_public_path__ + "img/pumping_station.6d6cb0f5.svg";